import { CommonModule } from '@angular/common'
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { AppState } from 'src/app/ngrx/states'
import { getCurrentPage } from 'src/app/ngrx/store/selectors'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { Version } from '../../enums/enums'
import { DdcAppstoreBtnSmallComponent } from '../ddc-appstore-btn-small/ddc-appstore-btn-small.component'

@Component({
  selector: 'ddc-footer',
  templateUrl: './ddc-footer.component.html',
  styleUrls: ['./ddc-footer.component.scss'],
  imports: [AngularMaterialsModules, CommonModule, RouterModule, DdcAppstoreBtnSmallComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcFooterComponent implements OnInit {
  _ddc_version: string = Version.STRING
  _isLoggedIn: boolean = true
  constructor(
    private logger: DdcLoggerService,
    private store: Store<AppState>,
  ) {}
  ngOnInit(): void {
    // get current page
    this.store.select(getCurrentPage).subscribe(page => {
      if (page == 'signup' || page == 'login') {
        this._isLoggedIn = false
      }
    })
  }
}
